import { axios } from "@/axios"

/**
 * Applies a custom event template to an event vault.
 *
 * @param {number} [templateId] - The ID of the template to be applied.
 * @param {number} [eventVaultId] - The ID of the event vault where the template should be applied.
 * @throws {Error} If either `templateId` or `eventVaultId` is missing.
 * @returns {Promise<string>} A message indicating the result of the template application.
 */
export async function applyEventTemplate(templateId?: number, eventVaultId?: number) {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to apply template. Please ensure `eventVaultId` is provided.",
    )
  }

  if (!templateId) {
    throw new Error("Missing `templateId` when attempting to apply template. Please ensure `templateId` is provided.")
  }

  const response = await axios.post(`api/template/${templateId}/apply?eventVaultid=${eventVaultId}`)

  return response.data?.Message
}
